/**
 * Strategem 60 (Spread the Rot): same overlay timing / anchor / sound as Betrayal (341), units only — rot_target.png.
 */
export const ROT_STRATEGEM_TARGET_IMAGE_PATH = '/images/rot_target.png';

export {
  BETRAYAL_SOUND_PATH as ROT_STRATEGEM_SOUND_PATH,
  BETRAYAL_TARGET_FADE_DURATION_MS as ROT_STRATEGEM_TARGET_FADE_DURATION_MS,
  BETRAYAL_TARGET_OVERLAY_WIDTH as ROT_STRATEGEM_TARGET_OVERLAY_WIDTH,
  BETRAYAL_TARGET_ANCHOR_OFFSET_X_PX as ROT_STRATEGEM_TARGET_ANCHOR_OFFSET_X_PX,
  BETRAYAL_TARGET_ANCHOR_OFFSET_Y_PX as ROT_STRATEGEM_TARGET_ANCHOR_OFFSET_Y_PX,
} from './betrayalStrategemAnimation';
